export default __webpack_public_path__ + "static/media/HTMLAcademy.4e45b710.jpg";